module.exports = __webpack_public_path__ + "graphics/12.ckh.24497d2cd211bc05ebd41da180d9801f.png";